import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import CarDeliveryTemplate from "../../sections/car-delivery-template";
import CarDatePicker from "../../react-components/car-date-picker";
import { selectUserState } from "../../selectors/application";
import { useQueryParams } from "../../utils/useQuery";
import api from "../../utils/api";
import { getBookingTimeSlots } from "../../services/bookingService";
import { isEmptyObject, redirect } from "../../utils/siteUtils";
import { useHistory } from "react-router-dom";
import { appendQuery } from "../../utils/urlHelper";
import { getOrderDetail, getOrderDetailByNo } from "../../services/orderService";
import { isBizNull } from "../../utils";
import moment from "moment";

const CarBookingDatetime = ({ fields }) => {
  /*Redux start*/
  const user = useSelector(selectUserState);
  /*Redux end*/
  const { template, locationHeadingType, locationHeadingBody, dateHeadingType, dateHeadingBody, okText, CancelText, noSlotsText, submitCTA } = fields;
  const { confirmationLink } = template?.fields || {};
  const { iconName, link, colorScheme } = submitCTA?.fields;
  const history = useHistory();
  const [workorderid, scheduleid, fromdate, todate, customerOrderNumber] = useQueryParams("workorderid", "scheduleid", "fromdate", "todate", "customerOrderNumber");
  const [openToDate, setOpenToDate] = useState(null);
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [location, setLocation] = useState(null);
  const [orderLoaded, setOrderLoaded] = useState(false);
  const [slotsLoaded, setSlotsLoaded] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);
  const [locationLoaded, setLocationLoaded] = useState(false);
  const [customerNotMatch, setCutomerNotMatch] = useState(false);
  const showLoading = useMemo(() => !orderLoaded || !slotsLoaded || !locationLoaded, [slotsLoaded, locationLoaded]);
  const carDeliveryDatePickerDetails = {
    customerNotMatch,
    showLoading,
    location
  };
  const timeAndDateDetails = {
    heading: {
      html: dateHeadingBody,
      type: dateHeadingType
    },
    calendarProps: {
      okButton: {
        buttonText: okText.value,
        width: "auto",
        icon: null,
        isDisabled: false
      },
      cancelLink: { text: CancelText.value, url: "#" },
      onDateSelect: data => { },
      showTime: true,
      onTimeSlotSelect: data => {
        setSelectedTime(data);
      },
      noSlotsText: noSlotsText?.value,
      openToDate,
      disablePreviousDates: true,
      availableTimeSlots
    },
    showCheckboxContainer: false,
    carDeliverySubmit: {
      buttonText: link?.value?.text,
      iconName,
      colorScheme,
      isDisabled: !selectedTime || !confirmationLink?.value.href,
      async callback(e) {
        e.preventDefault();
        const [startTime, endTime, resourceId] = selectedTime.value.split(" ");

        /** Measurements */
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "carDeliveryDateTime",
          eventCategory: "car delivery booking",
          eventAction: "date and time",
          eventLabel: startTime,
        });

        await api.booking.availableTimeSlot.book(null, {
          workOrderId: workorderid,
          selectedResourceId: resourceId,
          selectedStartDateTime: startTime,
          selectedEndDateTime: endTime
        });
        const url = appendQuery(confirmationLink?.value.href, {
          scheduleid,
          orderNo: customerOrderNumber,
          booking: global.btoa(encodeURIComponent(`${startTime.substr(0, 10)} ${selectedTime.startTime} ${selectedTime.endTime}`))
        });
        redirect(history, url, true);
      }
    },

    testDriveSubmit: {
      buttonText: link?.value?.text,
      iconName,
      colorScheme,
      isDisabled: !selectedTime || !confirmationLink?.value.href,
      async callback(e) {
        e.preventDefault();
        const [startTime, endTime, resourceId] = selectedTime.value.split(" ");
        await api.booking.availableTimeSlot.book(null, {
          workOrderId: workorderid,
          selectedResourceId: resourceId,
          selectedStartDateTime: startTime,
          selectedEndDateTime: endTime
        });
        const url = appendQuery(confirmationLink?.value.href, {
          scheduleid,
          orderNo: customerOrderNumber,
          booking: global.btoa(encodeURIComponent(`${startTime.substr(0, 10)} ${selectedTime.startTime} ${selectedTime.endTime}`))
        });
        redirect(history, url, true);
      }
    }
  };
  const initPage = async user => {
    const checkResult = await checkOrder(user);
    if (checkResult) {
      await Promise.all([loadLocation(), loadSlots()]);
    }
  };
  const checkOrder = async user => {
    const order = await getOrderDetailByNo(customerOrderNumber);
    const { orderExtraData, customerNumber } = order || {};
    if (customerNumber !== user.customerNumber) {
      setCutomerNotMatch(true);
      return false;
    }
    const { carStartDeliveryDate, carEndDeliveryDate } = orderExtraData || {};
    if (!isBizNull(carStartDeliveryDate) && !isBizNull(carEndDeliveryDate)) {
      const url = appendQuery(confirmationLink?.value.href, {
        scheduleid,
        orderNo: customerOrderNumber
      });
      redirect(history, url, true);
    }
    setOrderLoaded(true);
    return true;
  };
  const loadSlots = async () => {
    const slots = await getBookingTimeSlots(workorderid, fromdate, todate);
    setAvailableTimeSlots(slots);
    if (slots.length > 0) {
      setOpenToDate(slots[0].date);
    }
    setSlotsLoaded(true);
  };
  const loadLocation = async () => {
    const { data } = await api.booking.caseDetail.get({
      scheduleid
    });
    if (!isEmptyObject(data)) {
      const { DeliveryAddressStreet1, DeliveryAddressPostalCode, DeliveryAddressCity } = data;
      setLocation(`<p>${DeliveryAddressStreet1} <br/>${DeliveryAddressPostalCode} ${DeliveryAddressCity}</p>`);
    }
    setLocationLoaded(true);
  };
  useEffect(() => {
    initPage(user);
  }, [user]);
  return (
    <div className="car-delivery-date-wrapper">
      <CarDeliveryTemplate fields={fields}>
        <CarDatePicker fields={fields} {...carDeliveryDatePickerDetails} timeAndDateDetails={timeAndDateDetails} />
      </CarDeliveryTemplate>
    </div>
  );
};
export default withSitecoreContext()(CarBookingDatetime);
